// extracted by mini-css-extract-plugin
export var currencyInput = "_mf-1";
export var currencySymbol = "_mf-0";